module.exports = __webpack_public_path__ + "img/dancing_panda4.c6714f5d.gif";